import { makeAutoObservable, runInAction } from 'mobx'
import {
  NoticeList,
  NotificationList,
  ResNoticeDetail,
  ResNotificationDetail,
  SellList,
  UnreadCount,
  HttpReq,
} from '../common'
import RootStore from './root'
import { PagingSubStore, SingleSubStore } from './subStore'

export class NotificationStore {
  rootStore: RootStore
  unreadNotification: UnreadCount | null = null

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  /* 공지사항 */
  noticePagingStore = new PagingSubStore<NoticeList>('/notice') // 목록 조회
  noticeDetailStore = new SingleSubStore<ResNoticeDetail>( // 상세 조회
    (param?: Record<string, any>) => `/notice/${param?.notificationId}`,
  )

  /* 알림 */
  notificationPagingStore = new PagingSubStore<NotificationList>('/user/notifications/notifications') // 목록 조회
  notificationDetailStore = new SingleSubStore<ResNotificationDetail>( // 상세 조회
    (param?: Record<string, any>) => `/user/notifications/${param?.notificationId}`,
  )

  /* 매각 */
  sellPagingStore = new PagingSubStore<SellList>('/user/notifications/sell') // 목록 조회
  sellDetailStore = new SingleSubStore<ResNotificationDetail>( // 상세 조회
    (param?: Record<string, any>) => `/user/notifications/${param?.notificationId}`,
  )

  /* 읽지 않은 알림 있을 시 뱃지 표시를 위한 api */
  isReadNotification = async () => {
    const readNotification = await HttpReq<UnreadCount>({
      method: 'GET',
      url: `/user/notifications/unreadCount`,
    })
    if (readNotification == null) {
      return null
    }
    runInAction(() => {
      this.unreadNotification = readNotification
    })
    return readNotification
  }
}
